import { ValidationError } from "@/types/errors";

const UNKNOWN_ERROR = "Unknown error";

const toGeneralError = (msg: string): ValidationError => ({ loc: [], msg, type: "error" });

const toValidationError = (item: unknown): ValidationError | null => {
  if (typeof item === "string") {
    return item.trim() ? toGeneralError(item) : null;
  }
  if (!item || typeof item !== "object") {
    return null;
  }
  const record = item as Record<string, unknown>;
  if (typeof record.msg !== "string") {
    return null;
  }
  return {
    loc: Array.isArray(record.loc) ? (record.loc as (string | number)[]) : [],
    msg: record.msg,
    type: typeof record.type === "string" ? record.type : "error",
  };
};

/**
 * Coerces whatever an API call rejected or responded with (validation error list,
 * string, Error, `{ message }` / `{ error }` objects) into a list of validation errors.
 */
export const normalizeWorkflowErrors = (input: unknown): ValidationError[] => {
  if (Array.isArray(input)) {
    const errors = input
      .map(toValidationError)
      .filter((error): error is ValidationError => error !== null);
    return errors.length > 0 ? errors : [toGeneralError(UNKNOWN_ERROR)];
  }

  if (typeof input === "string") {
    return [toGeneralError(input.trim() || UNKNOWN_ERROR)];
  }

  if (input && typeof input === "object") {
    const single = toValidationError(input);
    if (single) {
      return [single];
    }
    const record = input as Record<string, unknown>;
    for (const key of ["message", "error"]) {
      const value = record[key];
      if (Array.isArray(value) || (typeof value === "string" && value.trim())) {
        return normalizeWorkflowErrors(value);
      }
    }
  }

  return [toGeneralError(UNKNOWN_ERROR)];
};
